"use client"

import { createContext, useContext } from "react"

import type { PointerEventHandler } from "react"

export type ModalSwipeDown = {
  onPointerDown: PointerEventHandler
  onPointerMove: PointerEventHandler
  onPointerUp: PointerEventHandler
  onPointerCancel: PointerEventHandler
}

// Own module so ModalShell (the provider) and useModalClose (the consumer) do
// not have to import each other through ModalProvider.
export const ModalInstanceContext = createContext<{
  close: (result?: unknown) => void
  swipe?: ModalSwipeDown
} | null>(null)

export function useModalInstance() {
  return useContext(ModalInstanceContext) ?? { close: () => {} }
}
